// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Variables */\n:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n/* Variables */\n:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
